import React from 'react'
// import "../../utils/tooltip.css"
// import { Tooltip } from 'primereact/tooltip';

const InfoIcon = (props) => {

    const { element, msg } = props
    return (
        <div className="flex flex-row align-items-center justify-content-start" style={{ width: '100%' }}>
            {/* <Tooltip target=".info" className='indigo-tooltip ml-2 shadow-none' /> */}
            {element}
            <i className="info pi pi-info-circle cursor-pointer" data-pr-tooltip={msg}
                data-pr-classname="text-primary" data-pr-position="right"
                style={{ color: "#00a8ff", marginLeft: '0.5rem', fontSize: '0.8rem' }} />
        </div>
    )
}

export default InfoIcon
